import React, { useState, useEffect } from 'react';

const SplashScreen = ({ onFinish }) => {
  const [fadeOut, setFadeOut] = useState(false);

  useEffect(() => {
    // Animation de sortie après 2 secondes
    const timer = setTimeout(() => {
      setFadeOut(true);
      // Callback après l'animation de fade out
      setTimeout(onFinish, 500);
    }, 2000);

    return () => clearTimeout(timer);
  }, [onFinish]);

  return (
    <div 
      className={`fixed inset-0 z-[9999] flex flex-col items-center justify-center bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 transition-opacity duration-500 ${fadeOut ? 'opacity-0' : 'opacity-100'}`}
    >
      {/* Cercles animés en arrière-plan */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-emerald-500/10 rounded-full blur-3xl animate-pulse" />
        <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-teal-500/10 rounded-full blur-3xl animate-pulse" style={{ animationDelay: '0.5s' }} />
      </div>

      {/* Contenu principal */}
      <div className="relative flex flex-col items-center">
        {/* Logo avec animation */}
        <div className="relative mb-8">
          {/* Cercle animé autour du logo */}
          <div className="absolute inset-0 -m-4">
            <svg className="w-32 h-32 animate-spin-slow" viewBox="0 0 100 100">
              <circle 
                cx="50" 
                cy="50" 
                r="45" 
                fill="none" 
                stroke="url(#gradient)" 
                strokeWidth="2"
                strokeDasharray="70 200"
                strokeLinecap="round"
              />
              <defs>
                <linearGradient id="gradient" x1="0%" y1="0%" x2="100%" y2="100%">
                  <stop offset="0%" stopColor="#10b981" />
                  <stop offset="100%" stopColor="#14b8a6" />
                </linearGradient>
              </defs>
            </svg>
          </div>
          
          {/* Logo */}
          <div className="w-24 h-24 bg-white/10 backdrop-blur rounded-2xl flex items-center justify-center shadow-2xl shadow-emerald-500/30 animate-bounce-subtle">
            <img 
              src="https://customer-assets-rejwkqb3.emergentagent.net/job_5700d295-d3ed-4629-8765-e98307778f89/artifacts/bbyq8lme_icone_verre_vert_512.png" 
              alt="copropriete.app" 
              className="w-20 h-20 object-contain rounded-xl"
            />
          </div>
        </div>

        {/* Nom de l'app */}
        <h1 className="text-3xl font-bold text-white mb-2 animate-fade-in">
          copropriete.app
        </h1>
        
        {/* Tagline */}
        <p className="text-slate-400 text-sm animate-fade-in-delayed">
          100% gratuit — Reprenez le contrôle
        </p>

        {/* Barre de chargement */}
        <div className="mt-8 w-48 h-1 bg-slate-700 rounded-full overflow-hidden">
          <div className="h-full bg-gradient-to-r from-emerald-500 to-teal-500 rounded-full animate-loading-bar" />
        </div>
      </div>

      {/* Footer */}
      <div className="absolute bottom-8 text-slate-500 text-xs">
        SAS GMP Developpement
      </div>

      {/* Styles d'animation */}
      <style>{`
        @keyframes spin-slow {
          from { transform: rotate(0deg); }
          to { transform: rotate(360deg); }
        }
        @keyframes bounce-subtle {
          0%, 100% { transform: translateY(0); }
          50% { transform: translateY(-10px); }
        }
        @keyframes fade-in {
          from { opacity: 0; transform: translateY(10px); }
          to { opacity: 1; transform: translateY(0); }
        }
        @keyframes loading-bar {
          0% { width: 0%; }
          100% { width: 100%; }
        }
        .animate-spin-slow {
          animation: spin-slow 3s linear infinite;
        }
        .animate-bounce-subtle {
          animation: bounce-subtle 2s ease-in-out infinite;
        }
        .animate-fade-in {
          animation: fade-in 0.5s ease-out forwards;
        }
        .animate-fade-in-delayed {
          opacity: 0;
          animation: fade-in 0.5s ease-out 0.3s forwards;
        }
        .animate-loading-bar {
          animation: loading-bar 1.8s ease-out forwards;
        }
      `}</style>
    </div>
  );
};

export default SplashScreen;
